module.exports = __webpack_public_path__ + "img/product-placeholder-7.fbc79d1.png";